// Imports
require('./bootstrap');
require('flatpickr/dist/flatpickr.css');
import '@trevoreyre/autocomplete-vue/dist/style.css'
import 'vue-toast-notification/dist/theme-sugar.css';


import moment from 'moment';
window.moment = moment;
moment.locale(document.documentElement.lang);
import Vue from 'vue';
import Vuikit from 'vuikit';
import router from './router'
import store from './store'
import accounting from 'accounting';
import VueTheMask from 'vue-the-mask';
import VueNumeric from 'vue-numeric';
import ToggleButton from 'vue-js-toggle-button';
import VueFlatPickr from 'vue-flatpickr-component';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import TextInput from './components/Common/TextInput'
import CustomTextarea from './components/Common/CustomTextarea'
import DatePicker from './components/Common/DatePicker'
import PhoneNumberInput from './components/Common/PhoneNumberInput'
import loading from 'vuejs-loading-screen'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import VueHtmlToPaper from './plugins/VueHtmlToPaper';
import VueTelInput from 'vue-tel-input'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask';
import GlobalMixins from '../mixins/global-mixins'
import VueCurrencyInput from 'vue-currency-input'
import VueToast from 'vue-toast-notification';
import { Lang } from './plugins/HopeLang';

Vue.config.silent = true;

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule])
})

// Register the plugin
Vue.use(Lang, {
  programTranslationsKey: process.env.MIX_LANG_KEY.replace('_', '')
});

// Use Statements
Vue.use(loading, {
  bg: '#2089a94d',
  icon: 'refresh',
  size: 3,
  icon_color: 'white',
})
Vue.use(Autocomplete)
Vue.use(Vuikit);
Vue.use(VueTheMask);
Vue.use(VueNumeric);
Vue.use(ToggleButton);
Vue.use(VueFlatPickr);
Vue.use(VueHtmlToPaper);
Vue.use(VueMask);
Vue.use(VueSweetalert2);
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VueTelInput, {
  validCharactersOnly: true,
  mode: 'national',
  name: 'phone_number',
  disabledFetchingCountry: true,
  onlyCountries: ["US"],
  dropdownOptions: {
    disabledDialCode: false
  },
  inputOptions: {
    showDialCode: false
  }
})
Vue.use(VueToast, {
	position: 'top-right',
});

const pluginOptions = {
  /* see config reference */
  globalOptions: {
    currency: 'USD',
  }
}
Vue.use(VueCurrencyInput, pluginOptions)

// Common Components
Vue.component('TextInput', TextInput)
Vue.component('CustomTextarea', CustomTextarea)
Vue.component('DatePicker', DatePicker)
Vue.component('PhoneNumberInput', PhoneNumberInput)

// Filters
Vue.filter('moment', function(value, format) {
	format = format || 'MM/DD/YYYY';
	return moment(value).format(format);
});

Vue.filter('formatMoney', (value) => {
    return accounting.formatMoney(value, '$', 2);
})

Vue.filter('formatNumber', (value, precision) => {
    precision = precision || 0
    return accounting.formatNumber(value, precision)
})

Vue.filter('obscuredName', (name) => {
    let nameArr = name.split(' ');
    return _.map(nameArr, (namePart, i) => {
        if(i === 0) {
            return namePart;
        }
        return namePart.substr(0,1)+'.';
    }).join(' ');
});

Vue.filter('bday', function (val) {
  return moment(val).format('ll')
})

Vue.mixin(GlobalMixins)

// Components
Vue.component('hope-app', require('./HopeApp').default);
Vue.component('landlord-wizard', require('./pages/LandlordWizard/LandlordWizard').default)
Vue.component('prequalification-form', require('./components/Home/PrequalificationForm/PrequalificationForm').default)
Vue.config.silent = true;

//check if Authorized once in a minute
window.checkAuth = function() {
	if(!store.state.App || !store.state.App.user || !store.state.App.user.id) return;
	axios.get('/api/hope/auth-check')
		.then(res => {
      if (res.data && !res.data.success) {
        document.cookie = "hope-auth-check=expired;;path=/";
        window.location.href = '/';
      }
		})
		.catch((error) => { });
}

// Boot up app
const app = new Vue({
	el: '#hope-app',
	router,
	store,
  mounted() {
    if (!window.authPing) {
      window.authPing = setInterval(window.checkAuth, 60*1000);
    }
  }
});

window.hope_lang_function = app.__;








